import React from 'react'
import BrandVw from '../../src/vectors/BrandVw'
import BrandKia from '../../src/vectors/BrandKia'
import BrandSkoda from '../../src/vectors/BrandSkoda'
import BrandVwCommercial from '../../src/vectors/BrandVwCommercial'
import BrandSeat from '../../src/vectors/BrandSeat'
import BrandCupra from '../../src/vectors/BrandCupra'
import BrandGWM from '../../src/vectors/BrandGWM'

const brandMap = {
  volkswagen: <BrandVw />,
  kia: <BrandKia />,
  skoda: <BrandSkoda />,
  'vw-commercial': <BrandVwCommercial />,
  seat: <BrandSeat />,
  cupra: <BrandCupra />,
  gwm: <BrandGWM />
}

export default (brand) => brandMap[brand.slug]
